document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.aperte-card-swatch');
  if (!swatch) return;

  const src = swatch.dataset.imageSrc;
  if (!src) return; // static display swatch — let click reach the card link

  e.stopPropagation();

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const img = card.querySelector('.card__media img');
  if (!img) return;

  const srcset = swatch.dataset.imageSrcset;
  const alt = swatch.dataset.imageAlt;

  if (srcset) img.srcset = srcset;
  img.src = src;
  if (alt !== undefined) img.alt = alt;

  card.querySelectorAll('.aperte-card-swatch').forEach(function (s) {
    s.removeAttribute('aria-pressed');
  });
  swatch.setAttribute('aria-pressed', 'true');
});
